import type { FC } from "react";

import type { DeliveryOption } from "@jti/commerce";
import { RadioButton, RadioButtonGroup } from "@jti/core-components";
import { FormField, useTranslations } from "@jti/ui";

import styles from "./DeliveryOptions.module.scss";

type Option = Pick<DeliveryOption, "methodCode" | "label">;

type DeliveryOptionsProps = {
  options: Option[];
  name: string;
};

export const DeliveryOptions: FC<DeliveryOptionsProps> = ({ name, options }) => {
  const { __ } = useTranslations();

  return (
    <div>
      <p>{__("cart.checkout.delivery.options_description")}</p>

      <FormField
        className={styles.radios}
        name={name}
        validation={{ required: __("validation.field_required") }}
        render={({ field }) => {
          return (
            <RadioButtonGroup name={field.name}>
              {options.map((option) => (
                <RadioButton
                  key={option.methodCode}
                  value={option.methodCode}
                  label={option.label}
                  checked={field.value === option.methodCode}
                  onChange={field.onChange}
                />
              ))}
            </RadioButtonGroup>
          );
        }}
      />
    </div>
  );
};
